import SearchSiteContainer from 'components/SearchSite/SearchSiteContainer'

export default {
  Container: SearchSiteContainer,
}
